/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>View front (down the Y axis)</h4>

<p>Switch view down the Y axis. Click again to switch to opposite (-Y) view direction.</p>

<p>Clicking on the orthogonal plane also flips view between Y and -Y direction</p>

<p>The up/down-arrow and left/right-arrow keys rotate view by 15 degrees.</p>`;

export default function ViewYTooptip() {
    return h('div', { innerHTML: body });
}
